<template lang="html">
  <div class="form-row align-items-center">
<!--    <div class="col-12">-->
    <section class="col-12 pt-3">
      <div class="form-row m-0">
      <label class="col-10 col-md-11 font-weight-bold pl-0">{{ isCommerce ? 'Nombre de la empresa' : 'Nombre' }}</label>
      <span class="col-2 col-md-1 font-weight-normal pl-2 d-flex justify-content-center hint">
        <TooltipIcon icon="fa fa-eye" text="Mostrar como dato de contacto" />
      </span>
      <CheckableText
          v-if="isCommerce"
          @focus="$emit('focus')"
          @blur="$emit('blur')"
          :isChecked="true"
          :value="person.fantasy_name"
          checkDisabled
          :textDisabled="!!person.fantasy_name"
          :tooltipText="'Siempre visible'"
          @textChanged="setFantasyName"/>
      <CheckableText
          v-else
          @focus="$emit('focus')"
          @blur="$emit('blur')"
          :isChecked="true"
          :value="person.first_name"
          checkDisabled
          :textDisabled="!!person.first_name"
          :tooltipText="'Siempre visible'"
          @textChanged="setFirstName"/>
    </div>
<!--    <div class="col-12">-->
<!--      <CheckableText-->
<!--          v-if="!isCommerce"-->
<!--          @focus="$emit('focus')"-->
<!--          @blur="$emit('blur')"-->
<!--          label="Apellido"-->
<!--          :isChecked="false"-->
<!--          :value="person.last_name"-->
<!--          checkDisabled-->
<!--          :textDisabled="!!person.last_name"-->
<!--          @checkChanged="updateField({ last_name_public: !person.last_name_public })"-->
<!--          @textChanged="setLastName"/>-->
<!--    </div>-->
    </section>
    <section class="col-12 pt-3">
        <div class="form-row m-0">
          <label class="col-10 col-md-11 font-weight-bold pl-0">Domicilio del vendedor</label>
          <span class="col-2 col-md-1 font-weight-normal pl-2 d-flex justify-content-center hint">
            <TooltipIcon icon="fa fa-eye" text="Mostrar como dato de contacto" />
          </span>
          <CheckableText
            v-for="(loc, index) in userLocations"
            @checkChanged="toggleLocation(loc)"
            @delete="handleRemoveLocation(loc)"
            :key="`loc-${index}`"
            :isChecked="checkLocation(loc.id)"
            :value="loc.string"
            :deletable="newLocations.some(l => l.formatted_address === loc.string)"
            :checkDisabled="checkLocation(loc.id) && onlyOneContactInfo"
            :tooltipText="'Mostrar como dato de contacto'"
            textDisabled />
          <br v-if="userLocations.length < 1"/>
          <button
            v-if="isCommerce || (!isCommerce && userLocations.length < 1)"
            @click.prevent="addNewLocation"
            class="btn btn-link text-secondary font-italic pl-0">
            <u>Agregar dirección</u>
          </button>
          <Loading class="mod-spinner" :active="isFetching"/>
        </div>
      </section>
    <section class="col-12 pt-3">
      <div class="form-row m-0">
          <label class="col-10 col-md-11 p-0 font-weight-bold">Teléfonos</label>
          <span class="col-2 col-md-1 font-weight-normal pl-2 d-flex justify-content-center hint">
            <TooltipIcon icon="fa fa-eye" text="Mostrar este dato de contacto" />
          </span>
          <CheckableText
            v-for="(phone, index) in formattedPhones"
            @checkChanged="togglePhone(phone)"
            :key="`ph-${index}`"
            :isChecked="checkPhone(phone)"
            :value="phone.phone"
            :unverified="!phone.verified"
            :checkDisabled="checkPhone(phone) && onlyOneContactInfo"
            :tooltipText="'Mostrar como dato de contacto'"
            type="text"
            textDisabled />
          <span v-if="phones.filter(p => !p.verified).length > 0"
                style="color: red; font-size: 16px;">
            * No verificado
          </span>
          <button
            @click.prevent="addNewPhone"
            class="btn btn-link text-secondary font-italic pl-0 w-100 text-left">
            <u>Agregar teléfono</u>
          </button>
        </div>
    </section>
    <section class="col-12 pt-3">
      <div class="form-row m-0">
        <label class="font-weight-bold col-10 col-md-11 pl-0">Emails</label>
        <span class="col-2 col-md-1 font-weight-normal pl-2 d-flex justify-content-center hint">
          <TooltipIcon icon="fa fa-eye" text="Mostrar como dato de contacto" />
        </span>
        <CheckableText
          v-for="(email, index) in emails"
          @checkChanged="toggleEmail(email)"
          :key="`email-${index}`"
          :isChecked="checkEmail(email)"
          :value="email.email"
          :checkDisabled="checkEmail(email) && onlyOneContactInfo"
          type="email"
          textDisabled />
      </div>
    </section>
  </div>
</template>

<script>
  import store from '@/store'
  import {instance as componentDialog} from '@/components/layout/ComponentDialog'
  import AddPhone from '@/components/user/AddPhone'
  import AddLocation from '@/components/user/AddLocation'
  import {formatPhone} from '@/helpers'

  const sellModule = store.state.sell

  export default {
    data: () => ({
      isFetching: false
    }),

    computed: {
      isCommerce: () => store.getters['user/isCommerce'],

      person: () => store.getters['user/person'],

      name: () => store.getters['user/name'],

      phones () { return store.state.user.phones.filter(p => (p.verified || this.checkPhone(p))) },

      publicationPhones: () => store.state.sell.phones,

      emails: () => store.state.user.emails.filter(e => e.verified),

      publicationEmails: () => store.state.sell.emails,

      userLocations: () => store.state.user.locations,

      newLocations: () => store.state.temps.newLocations || [],

      publicationLocations: () => store.state.sell.locations,

      onlyOneContactInfo () {
        const locations = this.publicationLocations && this.publicationLocations.length || 0
        const phones = this.publicationPhones && this.publicationPhones.length || 0
        const emails = this.publicationEmails && this.publicationEmails.length || 0
        return locations + phones + emails === 1
      },

      formattedPhones () { return this.phones.map(p => ({
        ...p,
        phone: formatPhone(p.phone.replace('+54', ''))
      }))
      }
    },

    methods: {
      formatPhone,

      updateUserInfo (data) {
        return store.dispatch('user/updateUserInfo', data)
      },

      setFirstName (name) {
        const data = {person: {physical_person: {first_name: name}}}
        return this.updateUserInfo(data)
      },

      setFantasyName (name) {
        const data = {person: {legal_person: {fantasy_name: name}}}
        return this.updateUserInfo(data)
      },

      setLastName (name) {
        const data = {person: {physical_person: {last_name: name}}}
        return this.updateUserInfo(data)
      },

      updateField: field => store.dispatch('sell/setOthers', field),

      handleRemoveLocation (loc) {
        this.isFetching = true
        store.dispatch('user/removeLocation', loc)
          .then(() => store.dispatch('user/fetchUserInfo'))
          .finally(() => {
            this.isFetching = false
          })
      },

      addNewPhone () {
        componentDialog({
          component: AddPhone,
          header: 'Agregar un nuevo teléfono',
          then: () => {
            const newPhoneIndex = this.phones.length - 1
            this.togglePhone(this.phones[newPhoneIndex])
          }
        })
      },

      addNewLocation () {
        componentDialog({
          component: AddLocation,
          header: 'Agregar una nueva ubicación',
          then: () => {
            const newLocationIndex = this.userLocations.length - 1
            this.toggleLocation(this.userLocations[newLocationIndex])
          }
        })
      },

      checkPhone (phone) {
        return this.publicationPhones.some(p => p.id === phone.id)
      },

      togglePhone (phone) {
        if (sellModule.id) {
          return this.checkPhone(phone)
            ? store.dispatch('sell/removePhone', phone)
            : store.dispatch('sell/addPhone', phone)
        }
      },

      checkEmail (email) {
        return this.publicationEmails.some(e => e.id === email.id)
      },

      toggleEmail (email) {
        if (sellModule.id) {
          return this.checkEmail(email)
            ? store.dispatch('sell/removeEmail', email)
            : store.dispatch('sell/addEmail', email)
        }
      },

      checkLocation (id) {
        return store.state.sell.locations.some(l => l.id === id)
      },

      toggleLocation (location) {
        if (sellModule.id) {
          return this.checkLocation(location.id)
            ? store.dispatch('sell/removeLocation', location)
            : store.dispatch('sell/addLocation', location)
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '../../../scss/colors';
  @import '../../../scss/aspect';

  .sell {
    padding-top: $navbar-height;
    background-color: $gray-200;

    &-location {
      background-color: $gray-200;
      padding: 0.5rem 1rem;
      // margin: 2px;

      &-checkbox {
        display: inline-block;
        padding: 0 0.25rem;
        margin-right: 0;

        & input {
          position: absolute;
          left: 1.25rem;
          width: 1rem;
          height: 1rem;
        }
      }

      &-close {
        color: $secondary;
        line-height: unset;
        cursor: pointer;
        position: absolute;
        top: 1rem;
        right: 1rem;
      }

      &-container {
        padding: 0.25rem;
      }

      &-group {
        margin-left: 0;
        margin-right: 0;
        width: 93%;
      }
    }

    .contact-title {
      line-height: 0.8rem;
    }

    .hint {
      top: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/sellPage/tabs/TabContactInfo.vue